var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#EFEFEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.46094,
    y: 9,
    width: 7.83269,
    height: 0.652724,
    rx: 0.326362,
    transform: "rotate(45 9.46094 9)",
    stroke: "#818181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.99951,
    y: 14.5386,
    width: 7.83269,
    height: 0.652724,
    rx: 0.326362,
    transform: "rotate(-45 8.99951 14.5386)",
    stroke: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTag);
export default __webpack_public_path__ + "static/media/remove-tag.39201b3e004adfb8ee89f7dd2a37e5ea.svg";
export { ForwardRef as ReactComponent };